<div id="page-home" class="page-container">
  <lynx-header></lynx-header>
  <div class="content-area">
    <router-outlet></router-outlet>
  </div>
</div>
